/**
 * Base URL of the saas-monitoring relay (frontend/server.ts, Bun, pm2 "saas-monitor-relay")
 * that stores alert rules, fires them, and delivers to Slack / Discord / Telegram / webhooks.
 *
 * Imported from vmprod saas-monitoring.tools.oddscomposer.io (App.vue → getDirectHttpUrl()).
 *
 *   DEV (vite)                              → /slack-manager-api  (proxied to 127.0.0.1:3100, see vite.config.js)
 *   console.<ocdevN>.dev.oddscomposer.io    → https://saas-monitoring.tools.<ocdevN>.dev.oddscomposer.io/relay
 *   anything else                           → https://saas-monitoring.tools.oddscomposer.io/relay
 *
 * nginx maps /relay/ → 127.0.0.1:3100/ on both ocdev2 and vmprod.
 * Override with VITE_SLACK_MANAGER_API_URL (no trailing slash needed).
 */
export function resolveSlackManagerApiBase() {
  const fromEnv = import.meta.env.VITE_SLACK_MANAGER_API_URL
  if (fromEnv) return String(fromEnv).replace(/\/$/, '')

  if (import.meta.env.DEV) return '/slack-manager-api'

  const host = (typeof window !== 'undefined' && window.location?.hostname) || ''
  const match = host.match(/\b(ocdev\d+)\.dev\.oddscomposer\.io$/i)
  if (match) {
    return `https://saas-monitoring.tools.${match[1].toLowerCase()}.dev.oddscomposer.io/relay`
  }
  return 'https://saas-monitoring.tools.oddscomposer.io/relay'
}
